<template>
  <v-col cols="12" class="d-flex justify-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="date"
          prepend-inner-icon="mdi-calendar-outline"
          v-bind="attrs"
          v-on="on"
          readonly
          filled
          rounded
          :label="`Please select week period`"
        />
      </template>
      <v-date-picker
        v-if="allowed_dates.length > 0"
        v-model="week"
        @input="getWeek($event)"
        :allowed-dates="getAllowedDates"
        :min="getDateLimit(allowed_dates).min"
        :max="getDateLimit(allowed_dates).max"
        :events="report_start_dates"
        event-color="green lighten-1"
        multiple
        show-adjacent-months
      ></v-date-picker>
    </v-menu>
  </v-col>
</template>

<script>
import moment from "moment";

export default {
  name: "ReportDateSelect",
  props: {
    allowed_dates: Array,
    report_start_dates: Array,
  },
  data: function () {
    return {
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      week: [],
      menu: false,
      week_number: null,
      year: null,
    };
  },
  created() {},
  mounted() {},
  methods: {
    getWeek(date) {
      const startDate = new Date(date[date.length - 1]);
      const startOfWeek = new Date(startDate);
      startOfWeek.setDate(startDate.getDate() - startDate.getDay());

      const daysOfWeek = [];
      for (let i = 0; i < 7; i++) {
        const currentDate = new Date(startOfWeek);
        currentDate.setDate(startOfWeek.getDate() + i);

        const day = currentDate.getDate().toString().padStart(2, "0");
        const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
        const year = currentDate.getFullYear();

        const formattedDate = `${year}-${month}-${day}`;
        daysOfWeek.push(formattedDate);
      }
      this.week = daysOfWeek;
      this.week_number = this.getWeekNumber(startDate);
      this.year = startDate.getFullYear();

      this.$emit("week-selected", {
        week: this.week,
        week_number: this.week_number,
        year: this.year,
      });
    },
    getWeekNumber(date) {
      return moment(date).week();
    },
    getDateLimit(available_dates) {
      const dateObjects = available_dates.map((dateString) => new Date(dateString));

      const minDate = new Date(Math.min(...dateObjects));
      const maxDate = new Date(Math.max(...dateObjects));

      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      return {
        min: formatDate(minDate),
        max: formatDate(maxDate),
      };
    },
    getAllowedDates: function (val) {
      return this.allowed_dates.indexOf(val) !== -1;
    },
  },
};
</script>
